import React, {useImperativeHandle, useRef} from 'react'
import WizModal from '../../../../components/modal/WizModal'
import Text from '../../../../components/text/Text'
import WizButton from '../../../../components/button/WizButton'
import useNavigation from '../../../../hooks/useNavigation'
import {ICommentList} from '../../../../apis/comment/getCommentList'
import {deleteCommentApi} from '../../../../apis/comment/deleteCommentApi'
import {ICommentDetail} from '../../../../apis/comment/getCommentDetail'

interface IProps {
    className?: string
    deleteData?: ICommentDetail
    deleteList?: ICommentList[]
}

const DeleteCommentModal = ({className, deleteData, deleteList}: IProps, ref: any) => {
    const {goCommentList} = useNavigation()
    const modalRef = useRef<any>()

    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
        },
    }))

    const onClickDelete = async () => {
        if (deleteData) {
            const parentId = [deleteData?.parent_id]
            const commentId = [deleteData?.id]
            await deleteCommentApi(parentId, commentId).then(res => {
                if (res?.data?.success) {
                    alert('Delete Comment')
                    goCommentList()
                }
            })
        }

        if (deleteList) {
            const parentId = []
            deleteList?.map(item => {
                if (parentId?.indexOf(item?.parent_id) < 0) {
                    parentId?.push(item?.parent_id)
                }
            })

            const commentId = []
            deleteList?.map(item => commentId?.push(item?.id))

            await deleteCommentApi(parentId, commentId).then(res => {
                if (res?.data?.success) {
                    alert('Delete Comments')
                    window.location.reload()
                }
            })
        }
        modalRef.current.close()
    }

    return (
        <>
            <WizModal title={'Remove Comment'} className={`${className}`} ref={modalRef}>
                <Text className={'text-body2 text-font02'}>해당 코멘트를 정말 삭제하시겠습니까? </Text>

                <div className={'flex space-x-[5px] mt-[30px]'}>
                    <WizButton
                        text={'Cancel'}
                        type={'cancel'}
                        className={'flex-1'}
                        onClick={() => {
                            modalRef.current.close()
                        }}
                    />
                    <WizButton text={'Remove'} type={'red'} className={'flex-1'} onClick={() => onClickDelete()} />
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(DeleteCommentModal)
